export default __webpack_public_path__ + "static/media/7.3218bb8a.jpg";